import { render, staticRenderFns } from "./CurrHelpList.vue?vue&type=template&id=0d5bea9b&"
import script from "./CurrHelpList.vue?vue&type=script&lang=js&"
export * from "./CurrHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports